import React from "react";
import { Paper, TableContainer, Table, TableBody, TableHead, TableRow, TableCell } from "@material-ui/core";
import LastWorksTableRow from "./LastWorksTableRow";
import PropTypes from "prop-types";

const LastWorksTable = ({ handleEditItem, handleDeleteItem, projects, pagination }) =>
  projects.length === 0 ? (
    <Paper className="p-4 text-center">لا توجد مشاريع</Paper>
  ) : (
    <TableContainer component={Paper} className="table-responsive">
      <Table className="table table-fixed">
        <TableHead>
          <TableRow className="last-news__theader">
            <TableCell align="center">#</TableCell>
            <TableCell align="center">اسم المشروع</TableCell>
            <TableCell align="center">تفاصيل المشروع</TableCell>
            <TableCell align="center">افعال</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {projects.map((project, index) => (
            <LastWorksTableRow
              handleEditItem={() => handleEditItem(project.id)}
              handleDeleteItem={() => handleDeleteItem(project.id)}
              key={project.id}
              {...project}
              index={index + 1}
              pagination={pagination}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

LastWorksTable.propTypes = {
  handleEditItem: PropTypes.func.isRequired,
  handleDeleteItem: PropTypes.func.isRequired,
  projects: PropTypes.array.isRequired,
};

export default LastWorksTable;
